"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _immutable = require("connected-react-router/immutable");
var _reactRouterDom = require("react-router-dom");
var _CornerstoneLoader = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneLoader"));
var _BaseLayout = _interopRequireDefault(require("cornerstone_ui_core/lib/containers/BaseLayout"));
var _DynamicRoutes = _interopRequireDefault(require("cornerstone_ui_core/lib/components/DynamicRoutes"));
var _CallbackHandler = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CallbackHandler"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AppRouter = _ref => {
  let {
    defaultRoute,
    routes,
    history
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_immutable.ConnectedRouter, {
    history: history
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_CornerstoneLoader.default, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/callback"
  }, /*#__PURE__*/_react.default.createElement(_CallbackHandler.default, {
    defaultRoute: defaultRoute
  })), /*#__PURE__*/_react.default.createElement(_BaseLayout.default, {
    routes: routes
  }, user => /*#__PURE__*/_react.default.createElement(_DynamicRoutes.default, {
    match: {
      url: ""
    },
    routes: routes
  }))))));
};
var _default = exports.default = AppRouter;